/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "utils/api";
import axios from "axios";
// import SnackBarComponent from "components/AlerComponent";
import LoaderComponent from "components/Loader";
import SnackBarComponent from "components/AlerComponent";
function Cover() {
  const navigate = useNavigate();

  const [openSnack, setOpenSnack] = useState(false);

  const [message, setMessage] = useState("");

  const handleCloseSnack = () => {
    setOpenSnack(false);
  };

  const [formLoading, setLoading] = useState(false);
  const [formState, setFormState] = useState({
    userName: "",
    email: "",
    password: "",
    cpassword: "",
    phone:""
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  }

  console.log(formState);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formState.cpassword !== formState.password) {
      alert("Passwords do not match");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post(`${baseUrl}/register`, {
        ...formState,
      });
      setLoading(false);
      if (res.status === 200) {
        // navigate to login page
        navigate("/signin");
      }
      // console.log(res);
    } catch (error) {
      setLoading(false);
      setMessage(error.response.data.msg);
      setOpenSnack(true);
      console.log(error);
    }
  };

  return (
    <>
      {openSnack && (
        <SnackBarComponent
          open={openSnack}
          message={message}
          handleClose={handleCloseSnack}
          type="Error"
        />
      )}
      {formLoading && <LoaderComponent open={true} />}

      <CoverLayout>
        <form onSubmit={handleSubmit} className="bg-grey-lighter mt-10 flex flex-col">
          <div className="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
            <div className="bg-white px-6 py-8 rounded shadow-md text-black w-full">
              <h1 className="mb-8 text-3xl text-center">Sign up</h1>
              <input
                required
                type="text"
                className="block border border-grey-light w-full p-3 rounded mb-4"
                name="userName"
                value={formState.userName}
                onChange={handleChange}
                placeholder="Full Name"
              />

              <input
                required
                type="email"
                className="block border border-grey-light w-full p-3 rounded mb-4"
                name="email"
                value={formState.email}
                onChange={handleChange}
                placeholder="Email"
              />

              <input
                required
                type="password"
                className="block border border-grey-light w-full p-3 rounded mb-4"
                name="password"
                value={formState.password}
                onChange={handleChange}
                placeholder="Password"
              />
              <input
                required
                type="password"
                className="block border border-grey-light w-full p-3 rounded mb-4"
                name="cpassword"
                value={formState.cpassword}
                onChange={handleChange}
                placeholder="Confirm Password"
              />

              <input
                required
                type="phone"
                className="block border border-grey-light w-full p-3 rounded mb-4"
                name="phone"
                value={formState.phone}
                onChange={handleChange}
                placeholder="Phone number"
              />

              <button
                type="submit"
                className="w-full cursor-pointer outline-none border-none text-center py-3 rounded bg-blue-400 text-white hover:bg-green-dark focus:outline-none my-1"
              >
                Create Account
              </button>
            </div>

            <div className="text-grey-dark mt-6">
              Already have an account?
              <span
                onClick={() => navigate("/signin")}
                className="no-underline text-blue-400 ml-2 cursor-pointer border-b border-blue text-blue"
              >
                Log in
              </span>
              .
            </div>
          </div>
        </form>
      </CoverLayout>
    </>
  );
}

export default Cover;
